import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-sm font-medium text-gray-700 mb-1"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["aria-checked", "onClick"]


export default {
  __name: 'SegmentedRadio',
  props: {
  options: { type: Array, required: true },
  modelValue: { type: [String, Number], default: null },
  label: { type: String, default: '' }
},
  emits: ['update:modelValue'],
  setup(__props) {





return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "flex rounded-md border border-gray-300 p-1",
      role: "radiogroup",
      "aria-label": __props.label || undefined
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
        return (_openBlock(), _createElementBlock("button", {
          key: option.value,
          type: "button",
          role: "radio",
          "aria-checked": option.value === __props.modelValue,
          class: _normalizeClass(["flex-1 px-4 py-1.5 text-sm font-medium rounded transition-colors", option.value === __props.modelValue ? 'bg-gray-100 text-gray-900' : 'text-gray-500 hover:text-gray-700']),
          onClick: $event => (_ctx.$emit('update:modelValue', option.value))
        }, _toDisplayString(option.label), 11, _hoisted_3))
      }), 128))
    ], 8, _hoisted_2)
  ]))
}
}

}